import { Component, OnInit } from '@angular/core';
import { ApiGetPageOptions, PagesStatus } from '@models/pages/page';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '@services/loader.service';
import { PagesService } from '@services/pages.service';
import moment from 'moment';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wsb-landing-stats',
  templateUrl: './landing-stats.component.html',
  styleUrls: ['./landing-stats.component.scss'],
  standalone: false
})
export class LandingStatsComponent implements OnInit {
  activeId = 1;
  scrollPagePages = 1;
  selectedPage;
  page;
  pages = [];
  backupPages;
  stopLoading = false;
  domains;

  urls: Map<
    number,
    {
      description: string;
      url: string;
    }
  > = new Map();

  url;

  private stringEmpty = '';
  private http = 'https://';

  periods = [
    {
      period: 'timefilter_dates_today',
      dateFrom: moment()
        .startOf('day')
        .format(),
      dateTo: new Date()
    },
    {
      period: 'timefilter_dates_thisweek',
      dateFrom: moment()
        .startOf('isoWeek')
        .format(),
      dateTo: new Date()
    },
    {
      period: 'timefilter_dates_thismonth',
      dateFrom: moment()
        .startOf('month')
        .format(),
      dateTo: new Date()
    },
    {
      period: 'timefilter_dates_lastmonth',
      dateFrom: moment()
        .startOf('month')
        .subtract(1, 'month')
        .format(),
      dateTo: moment()
        .startOf('month')
        .format()
    }
  ];

  public readonly loadingPeriod = {
    dateFrom: moment(new Date())
      .subtract(7, 'days')
      .format(),
    dateTo: new Date()
  };

  private search: Subject<string> = new Subject();

  constructor(private pagesService: PagesService, private translateService: TranslateService, private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.show();
    this.loadLandingPages();
    this.translatePeriods();
  }

  loadLandingPages() {
    const body = new ApiGetPageOptions();
    body.statuses = [PagesStatus.ONLINE, PagesStatus.OFFLINE, PagesStatus.ARCHIVED];
    // const body = {
    //   statuses: [PagesStatus.ONLINE, PagesStatus.OFFLINE, PagesStatus.ARCHIVED],
    // }
    this.pagesService
      .getPages(this.scrollPagePages, 1000, null, null, body)
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(pages => {
        if (pages.data.length === 0 && this.scrollPagePages === 1) {
          return (this.stopLoading = true);
        }
        if (pages.data.length === 0) {
          this.page = this.pages[0].idPage;
          this.selectedPage = this.pages[0];
          this.getUserDomains(this.pages);

          return this.pagesService.selectionChange.emit(this.selectedPage);
        }
        this.pages = [...this.pages, ...pages.data];
        this.scrollPagePages++;
        this.loadLandingPages();
      });
  }

  private getUserDomains(pages: Array<any>) {
    this.pagesService.getUserDomains().subscribe(domain => {
      this.domains = domain.data;

      pages.forEach(page => {
        this.urls.set(page.idPage, {
          description: page.description,
          url: this.getHtmlRenderUrlPage(page)
        });
      });
      this.url = this.urls.get(this.page).url;
    });
  }

  getUrl(idPage) {
    if (!idPage || this.urls.size === 0) {
      return;
    }
    return this.urls.get(idPage).url;
  }

  private getHtmlRenderUrlPage(page) {
    const status = page.status;
    switch (status) {
      case PagesStatus.ONLINE:
        return this.getPublishUrlBydomain(page);
      case PagesStatus.OFFLINE:
        return this.getUnPublishUrlBydomain(page);
      default:
        return this.stringEmpty;
    }
  }

  private getPublishUrlBydomain(page) {
    const domain = this.domains.find(d => d.idUserDomain === page.idUserDomain);
    return this.http + domain.domain + '/' + page.name;
  }

  private getUnPublishUrlBydomain(page) {
    const domain = this.domains.find(d => d.idUserDomain === page.idUserDomain);
    return domain.domain + '/' + page.name;
  }

  onSearch($event) {
    this.search.next($event.term);
  }

  setSelectedPage(page) {
    this.selectedPage = page;
    this.pagesService.selectionChange.emit(this.selectedPage);
    this.url = this.urls.get(page.idPage).url;
  }

  translatePeriods() {
    setTimeout(() => {
      this.periods.forEach(period => {
        period.period = this.translateService.instant(period.period);
      });

      this.periods = this.periods.slice();
    }, 1000);
  }
  // onScrollToEnd() {
  //   if (this.stopLoading) {
  //     return;
  //   }
  //   this.scrollPagePages++;
  //   this.pagesService.getPages(this.scrollPagePages).subscribe(pages => {
  //     if (pages.data.length === 0) {
  //       return (this.stopLoading = true);
  //     }
  //     this.pages = [...this.pages, ...pages.data];
  //   });
  // }

  // onClose() {
  //   this.stopLoading = true;
  //   this.scrollPagePages = 1;
  //   this.pages = this.backupPages;
  // }
}
